module.exports = __webpack_public_path__ + "static/fmcg-5134daf5d089bec5026952db1fa36c55.png";